import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";

export const ModalAnswers = ({ setIsModalOpen, data = [] }) => {
  const [questions, setQuestions] = useState([]);
  const [t] = useTranslation("monitoring");

  useEffect(() => {
    const tmpQuestions = data.filter(item => item.response !== null);
    console.log(tmpQuestions)
    setQuestions(tmpQuestions);
  }, [data])

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[50vw] h-[50vh] relative">
        <div className="bg-black text-white flex justify-between items-center px-4 py-2 rounded-t-lg">
          <h2 className="text-lg font-bold">{t("detailModal.answers")}</h2>
          <button
            className="text-white text-xl"
            onClick={() => setIsModalOpen(false)}
          >
            ✕
          </button>
        </div>
        <div className="p-4">
          <div className="h-96 overflow-y-auto">
            {questions.map((question, index) => (
              <div key={index} className="bg-gray-400 p-2 rounded-lg mb-2 font-semibold">
                {index + 1} - {question.name} : {question.response}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
